import { IComponentController, IComponentOptions } from 'angular';

import templateUrl from './agent-booking-mail-inprocess-forward.component.ajs.html';

const MODULE_NAME = 'agentBookingMailInprocessForward';

class AgentBookingMailInprocessForwardCtrl implements IComponentController {
  public name = MODULE_NAME;

  responseId: string;

  $onInit() {}
}

export class AgentBookingMailInprocessForward implements IComponentOptions {
  templateUrl = templateUrl;
  bindings = {
    responseId: '<',
  } as { [binding: string]: string };
  controller = [AgentBookingMailInprocessForwardCtrl];
}

export default MODULE_NAME;
